import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { useTrackView } from 'src/app/shared/hooks/tracking';
import { differenceInDays } from 'src/app/shared/utils/dates';

export function useTrackPageView(): void {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();
	useTrackView('petitions_dashboard_view', {
		score: petition.score,
		category_tags: petition.tagsConnection.nodes.map((tag) => tag.name),
		days_since_creation: differenceInDays(new Date(), new Date(petition.createdAt)),
	});
}
